"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var IQFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_IQFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2C.897 2 0 2.897 0 4v8c0 1.102.897 2 2 2h12c1.103 0 2-.898 2-2V4c0-1.103-.897-2-2-2ZM5 4.5h.5a.5.5 0 1 1 0 1H5a.5.5 0 1 1 0-1Zm-2.5 0H3a.5.5 0 1 1 0 1h-.5a.5.5 0 1 1 0-1Zm0 3h6a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1Zm.5 4h-.5a.5.5 0 1 1 0-1H3a.5.5 0 1 1 0 1Zm8 0H5a.5.5 0 1 1 0-1h6a.5.5 0 1 1 0 1Zm0-3h-.5a.5.5 0 1 1 0-1h.5a.5.5 0 1 1 0 1Zm2.5 3H13a.5.5 0 1 1 0-1h.5a.5.5 0 1 1 0 1Zm0-3H13a.5.5 0 1 1 0-1h.5a.5.5 0 1 1 0 1Zm0-3h-6a.5.5 0 1 1 0-1h6a.5.5 0 1 1 0 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_IQFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = IQFill;
exports["default"] = _default;